import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import roundButtonStyles from "./roundbutton.module.scss";

interface Props {
  menuId: string;
  icon?: IconProp;
}

const RoundDropdownButton = ({ menuId, icon = "cog" }: Props) => {
  // sub-renders
  const CustomToggle = forwardRef((props: any, ref: any) => (
    <button 
      ref={ref}
      className={`btn btn-sm ${roundButtonStyles.roundBtn}`}
      onClick={props.onClick}
    >
      <FontAwesomeIcon icon={icon}/>
    </button>
  ));

  // render
  return (
    <Dropdown.Toggle
      id={menuId}
      as={CustomToggle}
    />
  )
}

export default RoundDropdownButton;
